import React from "react";
import {observer} from "mobx-react";
import {StandardDialogPageComponent} from "../../../../../components/modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../../../../../components/modal/header/standard-dialog-header.component";
import {StandardDialogFooterComponent} from "../../../../../components/modal/footer/standard-dialog-footer.component";
import {SaveButtonBox} from "../../../../../components/forms/buttons/save-button.box";
import {IDialogConfirmationHandler} from "../../../../../services/dialog/dialog.service.interface";
import {
    IUserProfileEditorViewModel
} from "../../../../../services/user/models/profile/user-profile-editor-view-model.interface";
import {ValidationResultEnum} from "../../../../../types/validation-result.enum";
import {useServices} from "../../../../../hooks/use-services.hook";
import {AgencyContactInformationEditorComponent} from "./agency-contact-information-editor.component";
import {StandardDialogContentComponent} from "../../../../../components/modal/content/standard-dialog-content.component";

interface AgencyContactInformationEditorDialogComponentProps {
    dialogHandler: IDialogConfirmationHandler;
    userProfileEditor: IUserProfileEditorViewModel;
}

export const AgencyContactInformationEditorDialogComponent: React.FC<AgencyContactInformationEditorDialogComponentProps> = observer((props) => {
    const services = useServices();

    const onSave = async () => {
        const validationResult = await props.userProfileEditor.saveContactInformation();
        if(validationResult === ValidationResultEnum.Success) {
            props.dialogHandler.accept();
        }
    }

    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent title={services.language.translate('Edit contact information')}
                                           dialogHandler={props.dialogHandler}>

            </StandardDialogHeaderComponent>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <AgencyContactInformationEditorComponent userProfileEditor={props.userProfileEditor} />
            </StandardDialogContentComponent>
            <StandardDialogFooterComponent dialogHandler={props.dialogHandler}>
                <SaveButtonBox onClick={onSave}>
                    {services.language.translate('Save')}
                </SaveButtonBox>
            </StandardDialogFooterComponent>
        </StandardDialogPageComponent>
    );
})